import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";

export const SignaturePad = forwardRef(function SignaturePad({ onChange }, ref) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const hasInk = useRef(false);

  const setup = () => {
    const c = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    const { width, height } = c.getBoundingClientRect();
    c.width = width * ratio;
    c.height = height * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.4;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#18181B";
    hasInk.current = false;
    onChange?.(false);
  };

  useEffect(() => {
    setup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useImperativeHandle(ref, () => ({
    clear: setup,
    isEmpty: () => !hasInk.current,
    toBlob: () => new Promise((res) => canvasRef.current.toBlob(res, "image/png")),
  }));

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const down = (e) => {
    e.preventDefault();
    canvasRef.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(...pos(e));
    ctx.stroke();
    if (!hasInk.current) {
      hasInk.current = true;
      onChange?.(true);
    }
  };
  const up = () => { drawing.current = false; };

  return (
    <canvas ref={canvasRef} data-testid="signature-canvas"
      className="w-full h-48 sm:h-56 rounded-xl bg-white border-2 border-dashed border-[var(--border)] cursor-crosshair"
      style={{ touchAction: "none" }}
      onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} onPointerCancel={up} />
  );
});
